import styled from 'styled-components';

export const Message = styled.div``;

export const Avatar = styled.div`
  margin-top: 25px;

  width: 45px;
  height: 45px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(2, 6, 10, 1);
  border: 1px solid rgba(7, 137, 137, 1);

  > .img {
    width: 27px;
    height: 20px;
    display: block;
  }
`;

export const Content = styled.div`
  padding-top: 13px;
  > .nickname {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(173, 183, 189, 1);
    line-height: 1;
  }
  > .message {
    margin-top: 10px;

    box-sizing: border-box;
    padding: 15px 20px;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding-top: 13px;
  padding-bottom: 13px;
  box-sizing: border-box;

  overflow: hidden;
`;

export const FromContainer = styled(Container)`
  justify-content: flex-end;
  ${Avatar} {
    margin-left: 20px;
  }
  ${Content} {
    > .nickname {
    }

    > .message {
      background: rgba(255, 255, 255, 0.2);
      border: 1px solid rgba(0, 174, 174, 1);

      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(254, 254, 254, 1);
      line-height: 1;
      /* line-height: 18px; */
    }
  }
`;

export const ToContainer = styled(Container)`
  ${Avatar} {
  }
  ${Content} {
    margin-left: 20px;
    > .nickname {
    }

    > .message {
      background: rgba(0, 45, 61, 1);
      border: 1px solid rgba(1, 72, 72, 1);

      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 1;
      /* line-height: 46px; */
      color: rgba(254, 254, 254, 1);
    }
  }
`;
